import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { staffQueryKeys } from "./staffQueryKeys";

export function useStaffCreate({ api }: { api: ApiType }) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (newStaff: { [k: string]: any }) => {
      const newFields = { ...newStaff };

      delete newFields["picture"];

      const result = await api.staffApi.create(newFields);

      if (newStaff["picture"] && newStaff["picture"].blob) {
        await api.staffApi.updatePicture(result.data.id, newStaff["picture"]);
      }
      return result;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: staffQueryKeys.all() });
    },
  });
}
